import { TransferResult } from './outbound-calls.constants';

export type OutboundCallCampaign = { id: number; name: string };
export type OutboundCallLead = { id: number; name: string; nip: string | null };
export type OutboundCallContact = { id: number; full_name: string; position: string };
export type OutboundCallSalesperson = { id: number; name: string };

/** `GET /outbound_calls` row. A test call from the panel has no campaign, lead or contact. */
export type OutboundCall = {
  id: number;
  call_sid: string;
  phone: string | null;
  language: string | null;
  status: 'live' | 'resolved';
  end_reason: string | null;
  duration: number | null;
  answered_by: string | null;
  disposition: string | null;
  objective_completed: boolean | null;
  /** Opens with a reason code and a colon, then the agent's own words. */
  conclusion: string | null;
  extracted_data: Record<string, unknown> | null;
  created_at: string;
  scenario_id: number | null;
  scenario_name: string | null;
  trigger_source: string | null;
  triggered_by: string | null;
  company_id: number;
  campaign_entry_id: number | null;
  campaign: OutboundCallCampaign | null;
  lead: OutboundCallLead | null;
  contact: OutboundCallContact | null;
  transfer_attempts: number;
  transfer_result: TransferResult | null;
  transferred_to: OutboundCallSalesperson | null;
};

export type OutboundCallsResponse = {
  outbound_calls: OutboundCall[];
  outbound_calls_count: number;
};

export type OutboundCallsParams = {
  company_id: number;
  page?: number;
  items_per_page?: number;
  /** Matches the number or the lead's name. */
  query?: string;
  scenario_id?: number;
  campaign_id?: number;
  lead_id?: number;
  disposition?: string;
  trigger_source?: string;
  objective_completed?: boolean;
  /** YYYY-MM-DD, inclusive, the company's calendar day. */
  start_time?: string;
  end_time?: string;
};

export type PlaceTestCallPayload = {
  outbound_call_scenario_id: number;
  phone: string;
  language: string;
  opening_line?: string;
  use_preferred_language?: boolean;
};

export type PlaceTestCallResponse = { id: number; call_sid: string };

export const TEST_CALL_ERROR_CODES = [
  'invalid_params',
  'scenario_not_found',
  'language_not_supported',
  'twilio_rejected',
  'outbound_rejected',
] as const;

export type TestCallErrorCode = (typeof TEST_CALL_ERROR_CODES)[number];
